export const LEARN_MORE_LINK = 'http://help.playbookux.com/en/articles/4945441-workspace-templates';
